import type {ContactLastContactedTimeFragment, ContactPageFragment} from 'nutshell-graphql-types';
import {HeaderFieldType} from 'nutshell-graphql-types';

import {EditFieldsWrapper} from '../../shared/header/edit-fields/edit-fields-wrapper';
import {PeepLastContacted} from '../../shared/header/edit-fields/peep-last-contacted';
import {PeepTerritory} from '../../shared/header/edit-fields/peep-territory';

interface Props {
    contact: ContactPageFragment;
    contactLastContact: ContactLastContactedTimeFragment | null;
    isLoadingContactLastContact: boolean;
    canAccessSetup: boolean;
    onUpdateContactTerritory: (
        territoryId: string | null,
        territoryName: string | null
    ) => Promise<any>;
}

export function ContactEditFields(props: Props) {
    const headerFields = props.contact.headerFields;

    const enabledFields = new Set<HeaderFieldType>(
        headerFields.filter((f) => f.isEnabled).map((f) => f.type)
    );

    return (
        <EditFieldsWrapper>
            {enabledFields.has(HeaderFieldType.LAST_CONTACTED) && (
                <PeepLastContacted
                    entityType='contact'
                    lastContactedTime={props.contactLastContact?.lastContactedTime ?? null}
                    myLastContactedTime={props.contactLastContact?.myLastContactedTime ?? null}
                    isLoadingPeepLastContact={props.isLoadingContactLastContact}
                />
            )}
            {enabledFields.has(HeaderFieldType.TERRITORY) && (
                <PeepTerritory
                    territoryId={props.contact.territory?.id}
                    onUpdatePeepTerritory={(
                        territoryId: string | null,
                        territoryName: string | null
                    ) => {
                        props.onUpdateContactTerritory(territoryId, territoryName);
                    }}
                    canAccessSetup={props.canAccessSetup}
                />
            )}
        </EditFieldsWrapper>
    );
}
